import moment from 'moment';
import 'owl.carousel';

jQuery( document ).ready(function($) {
    $.ajax( {
        url: 'https://rest.bandsintown.com/artists/Victoria Monet/events?app_id=45PRESS_victoria',
        method: 'GET',
        dataType: 'json',
        error: () => {
        alert( 'Error fetching events!' );
        },
        success: data => {
            console.log(data);
        const events = $( '.events' );
        let html = '';
        if ( data.length ) {
        for ( let event of data ) {
            let location = event.venue.city + ', ' + (event.venue.region?event.venue.region:event.venue.country);
            if ( location === ', ' ) {location = '';}
            if ( event.venue.name.toLowerCase() === 'streaming live' ) {location = 'Online';}
            
            html += '<div class="event"><div>'
            html += '<p class="date">' + moment( event.datetime ).format( ' MMMM DD' ) + '</p>';
            html += '<p class="loc">' + event.venue.name + ' <br> ' + location + '</p>'
            html += '</div>'
            html += '<div class="links">';
            if(event.offers[0]){
            html += '<a href="' + event.offers[0].url + '" target="_blank" class="btn">' + event.offers[0].type + '</a>';
            } else {
            html += '<a href="' + event.url + '" target="_blank" class="btn">' + 'More Info' + '</a>';
            }
            if(event.offers[1]){
            html += '<a href="' + event.offers[1].url + '" target="_blank" class="btn">' + event.offers[1].type + '</a>';
            }
            html += '</div></div>';
        }
        events.html( html );
        } else {
            events.html( 'No upcoming events.' );
        }
    }
    });

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('#menu').toggleClass('active');
    })

    $('.owl-carousel').owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        items: 1
    })
});